export default __webpack_public_path__ + "images/AutumnPayrollApprovalBackground.web.png";